import script from "./ButtonCircularPlus.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonCircularPlus.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__